import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class PayrollContributionGroupingDTO  {
    _originalTypeClassName = "zERP.BO.PayrollContributionGroupingDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
PayrollContributionGroupingDTO.translate = translateService;
}
this.Name = null;
this.Amount = null;
this.EmployeerAmount = null;
this.PayrollContributionGroupingDTOKey = null;
this._key = this.PayrollContributionGroupingDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
Name:any;
Amount:any;
EmployeerAmount:any;
private _PayrollContributionGroupingDTOKey:any;
get PayrollContributionGroupingDTOKey(): any {
    return this._PayrollContributionGroupingDTOKey;
  }
set PayrollContributionGroupingDTOKey(value: any) {
    this._PayrollContributionGroupingDTOKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.PayrollContributionGroupingDTOKey == null || $this.PayrollContributionGroupingDTOKey == 0;
            }


}